import React, { useContext, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { DepositContext } from "@state/context/payment/DepositContext";

export default observer(function DepositPaymentMethodFilterSection() {
	const { t } = useTranslation("payment");
	const { register } = useFormContext();
	const { userPaymentMethods, fetchUserPaymentMethods } =
		useContext(DepositContext);

	useEffect(() => {
		fetchUserPaymentMethods();
	}, []);

	return (
		<div className="form__group">
			<label htmlFor="paymentMethodSelect" className="label">
				{t<string>("COMMON.PAYMENT_METHOD")}
			</label>
			<select
				id="paymentMethodSelect"
				className="input input--med input--select"
				{...register("paymentMethodId")}
			>
				<option key="paymentMethod-all" value="all">
					{t<string>("COMMON.ALL_METHODS")}
				</option>
				{userPaymentMethods?.map((paymentMethod: any) => (
					<option
						key={paymentMethod.paymentMethodId}
						value={paymentMethod.paymentMethodId}
					>
						{paymentMethod.displayName}
					</option>
				))}
			</select>
		</div>
	);
});
